module.exports = __webpack_public_path__ + "static/media/electrician.8ef5f193.jpg";